import React, { useState } from "react";
import { getIcon } from "../helper/vupComDash.helper";
import { FxmsData } from "../../fxms/datas/FxData";
import { DetailModal } from "../VupComDash_1";

const CommMeterStatus = ({ engId = undefined, dataRows, complexInloNo }) => {
  const [clickedEnergyId, setClickedEnergyId] = useState("");
  const [clickedCnt, setClickedCnt] = useState("");
  const [modal, setModal] = useState(false);

  let engList = FxmsData.getDatas("energy");
  let totCnt = 0;
  let onCnt = 0;
  let offCnt = 0;
  let engName = "";
  let filterData = "";

  if (
    Object.keys(dataRows.commMetStatus).length != 0 &&
    dataRows.commMetStatus[engId] != undefined
  ) {
    totCnt = dataRows.commMetStatus[engId][0].totCnt || 0;
    onCnt = dataRows.commMetStatus[engId][0].onCnt || 0;
    offCnt = dataRows.commMetStatus[engId][0].offCnt || 0;
  } else if (engId === undefined && dataRows.commMetStatus.comm !== undefined) {
    engId = "NET";
    totCnt = dataRows.commMetStatus.comm.totCnt || 0;
    onCnt = dataRows.commMetStatus.comm.onCnt || 0;
    offCnt = dataRows.commMetStatus.comm.offCnt || 0;
    engName = "사업장 통신";
  }

  filterData = engList.filter((obj) => obj.engId == engId)[0];
  if (filterData != undefined) {
    engName = filterData.engDescr + " 계측기";
  }

  const clickHandler = (click_id, click_cnt) => {
    setClickedEnergyId(click_id);
    setClickedCnt(click_cnt);
    setModal(!modal);
  };

  return (
    <>
      <div className="gb_title mb20">
        <img src={getIcon(engId)} />
        <h2>{engName} 현황</h2>
      </div>
      <div className="numBoxGroup">
        <div className="numBox mr20">
          <span>전체</span>
          <div className="num">
            <a
              id={engId}
              href="#"
              className="num"
              onClick={() => clickHandler(engId, "totalCnt")}
            >
              {totCnt}
            </a>
          </div>
        </div>
        <div className="numBox mr20">
          <span>정상</span>
          <div className="num">
            <a
              id={engId}
              href="#"
              className="num"
              onClick={() => clickHandler(engId, "onCnt")}
            >
              {onCnt}
            </a>
          </div>
        </div>
        <div className="numBox">
          <span>이상</span>
          <div className="num">
            <a
              id={engId}
              href="#"
              className="num"
              onClick={() => clickHandler(engId, "offCnt")}
            >
              {offCnt}
            </a>
          </div>
        </div>
      </div>
      {modal && (
        <DetailModal
          engId={clickedEnergyId}
          cnt={clickedCnt}
          setModal={setModal}
          open={true}
          complexInloNo={complexInloNo}
        />
      )}
    </>
  );
};

export default CommMeterStatus;
